var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { generateQueryParamsStr } from "../../utils/apiUtils";
const GET_SET_ORDER = 'api/v2/order';
const GET_SET_ORDER_OLD = 'api/order';
const GET_SET_ORDER_PAYMENTLINES = (orderId) => `/api/v2/order/${orderId}/paymentLines`;
export const updateById = function (id, data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.put(`${GET_SET_ORDER}/${id}`, data, config);
        }
        catch (error) {
            throw error;
        }
    });
};
export const updatePaymentLineById = function (orderId, id, data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.put(`${GET_SET_ORDER_PAYMENTLINES(orderId)}/${id}`, data, config);
        }
        catch (error) {
            console.error('Error fetching updateById:', error);
            throw error;
        }
    });
};
export const setOrderCancelledBySequence = function (sequence, storeId, data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.put(`${GET_SET_ORDER_OLD}/${sequence}/${storeId}/cancelled`, data, config);
        }
        catch (error) {
            console.error('Error fetching setOrderCancelledBySequence:', error);
            throw error;
        }
    });
};
export const setOrderCleaningBySequence = function (sequence, storeId) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.put(`${GET_SET_ORDER_OLD}/${sequence}/${storeId}/cleaning`, {}, config);
        }
        catch (error) {
            console.error('Error fetching setOrderCleaningBySequence:', error);
            throw error;
        }
    });
};
export const setOrderCleanedBySequence = function (sequence, storeId, data, params) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const queryParams = generateQueryParamsStr([
                'markOutsourcedAsReturned',
            ], params);
            return yield this.axiosInstance.put(`${GET_SET_ORDER_OLD}/${sequence}/${storeId}/cleaned?${queryParams}`, data, config);
        }
        catch (error) {
            console.error('Error fetching setOrderCleanedBySequence:', error);
            throw error;
        }
    });
};
export const setOrderCollectedBySequence = function (sequence, storeId, data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.put(`${GET_SET_ORDER_OLD}/${sequence}/${storeId}/collected`, data, config);
        }
        catch (error) {
            throw error;
        }
    });
};
export const setOrdePickingBySequence = function (sequence, storeId, data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.put(`${GET_SET_ORDER_OLD}/${sequence}/${storeId}/picking`, data, config);
        }
        catch (error) {
            console.error('Error fetching setOrdePickingBySequence:', error);
            throw error;
        }
    });
};
export const setOrdeDeliveringBySequence = function (sequence, storeId, data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.put(`${GET_SET_ORDER_OLD}/${sequence}/${storeId}/delivering`, data, config);
        }
        catch (error) {
            console.error('Error fetching setOrdeDeliveringBySequence:', error);
            throw error;
        }
    });
};
export const setOrdeDeliveredBySequence = function (sequence, storeId, data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.put(`${GET_SET_ORDER_OLD}/${sequence}/${storeId}/delivered`, data, config);
        }
        catch (error) {
            throw error;
        }
    });
};
export const setOrderAcceptedBySequence = function (sequence, storeId) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.put(`${GET_SET_ORDER}/${sequence}/${storeId}/accepted`, {}, config);
        }
        catch (error) {
            console.error('Error fetching setOrderAcceptedBySequence:', error);
            throw error;
        }
    });
};
export const bulkCancel = function (storeId, body) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.put(`${GET_SET_ORDER}/${storeId}/bulkCancel`, body, config);
        }
        catch (error) {
            console.error('Error fetching bulkCancel:', error);
            throw error;
        }
    });
};
export const bulkClean = function (storeId, body, params) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const queryParams = generateQueryParamsStr([
                'markOutsourcedAsReturned',
            ], params);
            return yield this.axiosInstance.put(`${GET_SET_ORDER}/${storeId}/bulkClean?${queryParams}`, body, config);
        }
        catch (error) {
            console.error('Error fetching bulkClean:', error);
            throw error;
        }
    });
};
export const bulkCollect = function (storeId, body) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.put(`${GET_SET_ORDER}/${storeId}/bulkCollect`, body, config);
        }
        catch (error) {
            throw error;
        }
    });
};
